import { AbstractStorage } from "@clairejs/client";
import { useEffect, useMemo } from "react";

import { ColorMode } from "../store/store";

import { useDispatch, useInject, useStore } from "./system";

const STORAGE_KEY = "COLOR_MODE";
const DEFAULT_MODE: ColorMode = "light";

export const useColorMode = () => {
    const storage = useInject(AbstractStorage);
    const dispatch = useDispatch((s) => s.ui?.color);

    const mode = useStore((s) => s.ui?.color?.mode);

    const setMode = (mode: ColorMode) => {
        storage.setItem(STORAGE_KEY, mode).then(() => {
            dispatch({ mode });
        });
    };

    const loadMode = () => {
        storage
            .getItem<ColorMode>(STORAGE_KEY)
            .then((mode) => setMode(mode || DEFAULT_MODE))
            .catch(() => setMode(DEFAULT_MODE));
        setMode(mode || DEFAULT_MODE);
    };

    const explicitMode = useMemo(() => {
        if (mode === "auto") {
            return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
        }

        return mode;
    }, [mode]);

    useEffect(() => {
        dispatch({ explicitMode });
    }, [explicitMode]);

    return {
        mode,
        loadMode,
        setMode,
    };
};
